
export class AlertPopupNotificationResponse {

  public static readonly ALERT_TYPE_MANUAL_ALERT = 'MANUAL_ALERT';
  public static readonly ALERT_TYPE_SUPPORT_TICKET_ALERT = 'SUPPORT_TICKET_ALERT';
  public static readonly ALERT_TYPE_DEVICE_ALERT = 'DEVICE_ALERT';

  uniqueId: string;
  alertTitle: string;
  alertDescription: string;
  alertType: string;
  assetName: string;
  lineName: string;
  severity: string;

  constructor(uniqueId: string = '',
              alertTitle: string = '',
              alertDescription: string = '',
              alertType: string = '',
              assetName: string = '',
              lineName: string = '',
              severity: string = '') {
    this.uniqueId = uniqueId;
    this.alertTitle = alertTitle;
    this.alertDescription = alertDescription;
    this.alertType = alertType;
    this.assetName = assetName;
    this.lineName = lineName;
    this.severity = severity;
  }

  isManualAlert(): boolean {
    return this.alertType === AlertPopupNotificationResponse.ALERT_TYPE_MANUAL_ALERT
  }

  isSupportTicketAlert(): boolean {
    return this.alertType === AlertPopupNotificationResponse.ALERT_TYPE_SUPPORT_TICKET_ALERT;
  }

  isDeviceAlert(): boolean {
    return this.alertType === AlertPopupNotificationResponse.ALERT_TYPE_DEVICE_ALERT;
  }

  isClose(): boolean {
    // Only DEVICE_ALERT supports "closed" at the moment.
    return this.severity === 'CLOSE';
  }

  isOpen(): boolean {
    return this.severity === 'OPEN' ;
  }

  isAcknowledge(): boolean {
    return this.severity === 'ACKNOWLEDGED' ;
  }

  public static fromObject(obj: any): AlertPopupNotificationResponse {
    let response = new AlertPopupNotificationResponse();
    response = Object.assign(response, obj);
    return response;
  }
}
